bam-gallery-slider {
  display: block;

  @include tablet() {
    overflow: hidden;
  }

  .is-overflow-hidden {
    @include mobile() {
      overflow: hidden;
    }
    @include tablet() {
      overflow: visible;
    }
    @include desktop() {
      overflow: visible;
    }
  }

  .is-shadow-left {
    @include desktop() {
      position: relative;

      & > div {
        clip-path: polygon(0 0, 0 100%, 200% 100%, 200% 0);
      }

      &::after {
        display: block;
        position: absolute;
        content: " ";
        left: calc(var(--bal-column-gap) + 0.5px);
        top: 0;
        height: calc(90% - 48px);
        width: 20px;
        background: transparent radial-gradient(ellipse at left, rgba(0, 0, 0, 0.15) 0%, rgba(255, 255, 255, 0) 68%, rgba(255, 255, 255, 0) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#a6000000', endColorstr='#00000000', GradientType=1);
        z-index: -1;
      }
    }
  }

  .bal-swiper__inner {
    overflow: visible;
    position: relative;
  }

  bam-carousel-item-content {
    width: 100%;
    box-sizing: border-box;
  }

  .bal-swiper__controls {
    position: relative;
    display: grid;
    justify-items: center;
    align-items: center;
    justify-content: center;
    grid-template-areas: "btn btn";
    margin-top: 48px;
    align-content: center;

    bal-button {
      display: block !important;
      position: relative !important;
      padding: 0 25px 0 25px;
    }
  }


  bal-carousel-item {
    @include desktop() {
      padding-top: 40px;
      padding-bottom: 20px;
    }
    
    &:first-child {
      @include desktop() {
        &::after {
          content: " ";
          width: 30px;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background-color: white;
        }
      }
    }

    height: auto !important;
    align-items: stretch !important;

    width: 100% !important;

    @include tablet() {
      width: calc(50% - (17px / 2)) !important;
    }

    @include desktop() {
      width: calc(37.5% - (40px / 2)) !important;
    }

    &:not(:last-child) {
      & > * {
        padding-right: 8px;

        @include tablet() {
          padding-right: 17px;
        }
  
        @include desktop() {
          padding-right: 40px;
        }
      }
    }

    &:first-child {
      @include desktop() {
        padding-left: 40px;
      }
    }
  }

  .is-button-flex-end {
    height: 100%;

    bal-button {
      margin-top: auto;
    }
  }


  .bal-carousel__inner::before,
  .bal-carousel__inner::after {
    content: none;
  }
}
